import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import errorIconSrc from '../assets/Error.svg'

export const errorIcon = css`
  inline-size: ${spacing(3)};
  block-size: ${spacing(3)};
  background: url(${errorIconSrc}) center center no-repeat;
  background-size: contain;
  background-repeat: no-repeat;
`
